module.exports = __webpack_public_path__ + "img/full7-min.7fa1dd33.png";